/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MembershipStatus,
    MembershipStatusFromJSON,
    MembershipStatusFromJSONTyped,
    MembershipStatusToJSON,
} from './MembershipStatus';

/**
 * 
 * @export
 * @interface MembershipCreateParams
 */
export interface MembershipCreateParams {
    /**
     * 
     * @type {string}
     * @memberof MembershipCreateParams
     */
    program_id: string;
    /**
     * 
     * @type {string}
     * @memberof MembershipCreateParams
     */
    default_payment_method?: string;
    /**
     * An ISO 8601-compliant string ('yyyy-MM-dd').
     * @type {string}
     * @memberof MembershipCreateParams
     */
    cancel_at?: string;
    /**
     * An ISO 8601-compliant string ('yyyy-MM-dd').
     * @type {string}
     * @memberof MembershipCreateParams
     */
    trial_end?: string;
    /**
     * An ISO 8601-compliant string ('yyyy-MM-dd').
     * @type {string}
     * @memberof MembershipCreateParams
     */
    trial_start?: string;
    /**
     * 
     * @type {MembershipStatus}
     * @memberof MembershipCreateParams
     */
    status?: MembershipStatus;
    /**
     * 
     * @type {boolean}
     * @memberof MembershipCreateParams
     */
    cancel_at_period_end?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MembershipCreateParams
     */
    timezone?: string;
    /**
     * An ISO 8601-compliant string ('yyyy-MM-dd').
     * @type {string}
     * @memberof MembershipCreateParams
     */
    start_date?: string;
    /**
     * 
     * @type {string}
     * @memberof MembershipCreateParams
     */
    contact_id: string;
    /**
     * 
     * @type {string}
     * @memberof MembershipCreateParams
     */
    program_attendee_id: string;
    /**
     * 
     * @type {string}
     * @memberof MembershipCreateParams
     */
    package_id: string;
}

export function MembershipCreateParamsFromJSON(json: any): MembershipCreateParams {
    return MembershipCreateParamsFromJSONTyped(json, false);
}

export function MembershipCreateParamsFromJSONTyped(json: any, ignoreDiscriminator: boolean): MembershipCreateParams {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'program_id': json['program_id'],
        'default_payment_method': !exists(json, 'default_payment_method') ? undefined : json['default_payment_method'],
        'cancel_at': !exists(json, 'cancel_at') ? undefined : json['cancel_at'],
        'trial_end': !exists(json, 'trial_end') ? undefined : json['trial_end'],
        'trial_start': !exists(json, 'trial_start') ? undefined : json['trial_start'],
        'status': !exists(json, 'status') ? undefined : MembershipStatusFromJSON(json['status']),
        'cancel_at_period_end': !exists(json, 'cancel_at_period_end') ? undefined : json['cancel_at_period_end'],
        'timezone': !exists(json, 'timezone') ? undefined : json['timezone'],
        'start_date': !exists(json, 'start_date') ? undefined : json['start_date'],
        'contact_id': json['contact_id'],
        'program_attendee_id': json['program_attendee_id'],
        'package_id': json['package_id'],
    };
}

export function MembershipCreateParamsToJSON(value?: MembershipCreateParams | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'program_id': value.program_id,
        'default_payment_method': value.default_payment_method,
        'cancel_at': value.cancel_at,
        'trial_end': value.trial_end,
        'trial_start': value.trial_start,
        'status': MembershipStatusToJSON(value.status),
        'cancel_at_period_end': value.cancel_at_period_end,
        'timezone': value.timezone,
        'start_date': value.start_date,
        'contact_id': value.contact_id,
        'program_attendee_id': value.program_attendee_id,
        'package_id': value.package_id,
    };
}

